import { render } from "./SystemInformation.vue?vue&type=template&id=53984039&scoped=true&ts=true"
import script from "./SystemInformation.vue?vue&type=script&lang=ts"
export * from "./SystemInformation.vue?vue&type=script&lang=ts"

import "./SystemInformation.vue?vue&type=style&index=0&id=53984039&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53984039"]])

export default __exports__